import React, { Component } from 'react';
import { connect } from 'dva';
import Container from '@/components/Container';
import Iframe from '@/components/Iframe';

@connect(({ user }) => ({
  orgId: user?.currentUser?.orgId,
  enOrgType: user?.currentUser?.enOrgType,
}))
class BaseStatistics extends Component {
  constructor(props) {
    super(props);
    this.iframe = React.createRef();
  }

  requestFullScreen = () => {
    const element = document.getElementById('mainFrame');
    const requestMethod =
      element.requestFullScreen ||
      element.webkitRequestFullScreen ||
      element.mozRequestFullScreen ||
      element.msRequestFullScreen;
    if (requestMethod) {
      requestMethod.call(element);
    } else if (typeof window.ActiveXObject !== 'undefined') {
      const wscript = new ActiveXObject('WScript.Shell');
      if (wscript !== null) {
        wscript.SendKeys('{F11}');
      }
    }
  };

  render() {
    const { enOrgType, orgId } = this.props;

    if (!enOrgType || !orgId) {
      return null
    }

    const IframeDom = Iframe({
      src: `https://datav.aliyuncs.com/share/${enOrgType === 'county_bureau_educ' ? 'e7cc8ad7f9d3e162e29d6b226de7a81a' : 'f94ec165b2e36c2700100487cf22039e'}?org_id=${orgId}`,
      seamless: 'seamless',
      allowfullscreen: "true",
      mozallowfullscreen: "true",
      'data-id': "client-account",
    });

    return (
      <Container breStates defaultPadding>
        <div style={{padding: '9px 17px'}}>
          <IframeDom />
        </div>
      </Container>
    );
  }
}

export default BaseStatistics;
